import { namedStateMapProvider } from "./namedState";

export const stockState = namedStateMapProvider( 'stocks' );